const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/laura.png"
    {...props}
  />
);

export default Logo;
